import { ProfessionalLinkLinkStatus } from "gli-api";

export interface ProfesionalStatusChange {
    userId: number;
    serviceProviderId: number;
    newStatus: ProfessionalLinkLinkStatus;
    emrConnections?: number[];
}
